import createReducer from '../utils/createReducer';
import NavigationActions from '../actions/navigationActions';
import {NavigationRecord} from '../records/navigationRecord';

const initialState = new NavigationRecord();

const actionHandlers = {
    [NavigationActions.NAV_SET_ACTIVE_TAB](state, {payload}) {
        const {navActiveTabIndex} = payload;

        return state.merge({navActiveTabIndex});
    },
    [NavigationActions.UPDATE_WAYPOINT_VISIBILITY](state, {payload = {}}) {
        const {waypointId, value} = payload;
        const updatedWaypointsInView = state.waypointsInView.set(waypointId, value);

        return state.merge({waypointsInView: updatedWaypointsInView});
    }
};

export default createReducer(actionHandlers, initialState);
